import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customCurrencyLight',
})
export class CustomCurrencyLightPipe implements PipeTransform {
  transform(value: number | undefined): string {
    if (value == null) {
      return '';
    }

    const [inteiro, decimal] = value.toFixed(2).split('.');

    const milhar = inteiro.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return `R$ ${milhar},${decimal}`;
  }
}
